import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Button, { FlexButtonGroup } from '@pattern-library/buttons';
export const propTypes = {
  /**
   * Toggle the appearance of a close button in the footer
   **/
  hasFooterClose: PropTypes.bool.isRequired,
  /**
   * Add additional classes to the close button in the footer
   **/
  footerCloseButtonClasses: PropTypes.string,
  /**
   * Update the text of the close button in the footer
   **/
  footerCloseButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * An element, node, or array of nodes that will appear in the modal footer.
   * This will override the footerButtons prop
   */
  footerChildren: PropTypes.node,
  /**
   * array of objects that defines the buttons that will appear in the footer
   **/
  footerButtons: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Button Type; Options: button, submit, reset
     **/
    type: PropTypes.oneOf(['button', 'submit', 'reset']).isRequired,
    /**
     * Class appended to asc-btn; Options: asc-btn--secondary, asc-btn--teritary, asc-btn--small, asc-btn--link, asc-btn--dropdown, asc-btn--icon, asc-btn--left, asc-btn--right, or any other class name
     **/
    className: PropTypes.string,
    /**
     * Is disabled
     **/
    disabled: PropTypes.bool,
    /**
     * Text to display on button
     **/
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    /**
     * Function to execute on click
     **/
    clickHandler: PropTypes.func,
    /**
     * Override for displaying loader
     **/
    showLoading: PropTypes.bool,
    /**
     * Unique ID for locating this button element in the DOM
     */
    qaId: PropTypes.string,
    /**
     * Displayed text while button is in its loading state
     */
    loadingText: PropTypes.string
  })),
  /**
   * Alignment of the footer buttons
   */
  footerButtonAlignment: PropTypes.oneOf(['center', 'left', 'right', 'spread']),
  /**
   * Stack the buttons vertically, either at all viewports (if true) or at or
   * below the given viewport (if 'small' or 'medium').
   */
  footerButtonBlock: FlexButtonGroup.propTypes.block,
  /**
   * When in block style, buttons can either stack in "normal" or "reverse" order.
   * Defaults to normal.
   */
  footerButtonBlockDirection: FlexButtonGroup.propTypes.blockDirection,
  /**
   * Function that closes the modal
   **/
  closeHandler: PropTypes.func
};
function ModalFooter(_ref) {
  let {
    closeHandler = () => {},
    footerButtonAlignment,
    footerButtonBlock,
    footerButtonBlockDirection,
    footerButtons = [],
    footerChildren,
    footerCloseButtonClasses = 'asc-btn--small asc-btn--secondary',
    footerCloseButtonText = 'Cancel',
    hasFooterClose
  } = _ref;
  // Map button clickhandlers so that they close the modal on click
  footerButtons = footerButtons.map(btn => {
    btn.clickCloseHandler = event => {
      let handler = btn.clickHandler(event);

      // if the click handler is a promise,
      // wait until the promise is fulfilled to close the modal
      if (handler && handler instanceof Promise) {
        return handler.then(closeHandler);
      }
      return closeHandler();
    };
    return btn;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-modal-footer"
  }, /*#__PURE__*/React.createElement(FlexButtonGroup, {
    alignment: footerButtonAlignment,
    block: footerButtonBlock,
    blockDirection: footerButtonBlockDirection
  }, hasFooterClose && /*#__PURE__*/React.createElement(Button, {
    className: footerCloseButtonClasses,
    type: "button",
    text: footerCloseButtonText,
    clickHandler: closeHandler
  }), footerChildren ? footerChildren : footerButtons && footerButtons.map((btn, i) => {
    return /*#__PURE__*/React.createElement(Button, _extends({
      key: i
    }, btn, {
      clickHandler: btn.clickCloseHandler
    }));
  })));
}
ModalFooter.propTypes = propTypes;
export default ModalFooter;